export default __webpack_public_path__ + "static/media/icon-Hegic.e537c8cb.svg";